{
  "TEAMS_SETTINGS": {
    "NEW_TEAM": "Δημιουργήσετε νέα ομάδα",
    "HEADER": "Ομάδες",
    "LOADING": "Fetching teams",
    "DESCRIPTION": "Teams allow you to organize agents into groups based on their responsibilities. An agent can belong to multiple teams. When working collaboratively, you can assign conversations to specific teams.",
    "LEARN_MORE": "Learn more about teams",
    "LIST": {
      "404": "Δεν έχουν δημιουργηθεί ομάδες σε αυτόν τον λογαριασμό.",
      "EDIT_TEAM": "Επεξεργασία ομάδας",
      "NONE": "Κανένα"
    },
    "CREATE_FLOW": {
      "CREATE": {
        "TITLE": "Δημιουργήσετε νέα ομάδα",
        "DESC": "Προσθέστε έναν τίτλο και περιγραφή στη νέα ομάδα."
      },
      "AGENTS": {
        "BUTTON_TEXT": "Προσθήκη πρακτόρων στην ομάδα",
        "TITLE": "Προσθήκη πρακτόρων στην ομάδα - {teamName}",
        "DESC": "Προσθέστε Πράκτορες στη νέα σας ομάδα. Αυτό σας επιτρέπει να συνεργάζεστε ως ομάδα σε συνομιλίες και να ενημερώνεστε για νέα συμβάντα στην συνομιλία."
      },
      "WIZARD_CREATE": {
        "TITLE": "Δημιουργία",
        "BODY": "Δημιουργήστε μια νέα ομάδα πρακτόρων."
      },
      "WIZARD_ADD_AGENTS": {
        "TITLE": "Προσθήκη Πρακτόρων",
        "BODY": "Προσθήκη πρακτόρων στην ομάδα."
      },
      "WIZARD_FINISH": {
        "TITLE": "Τέλος",
        "BODY": "Είσαστε έτοιμοι να ξεκινήσετε!"
      }
    },
    "EDIT_FLOW": {
      "CREATE": {
        "TITLE": "Επεξεργασία λεπτομερειών ομάδας",
        "DESC": "Επεξεργαστείτε τον τίτλο και την περιγραφή της ομάδας σας.",
        "BUTTON_TEXT": "Ενημέρωση ομάδας"
      },
      "AGENTS": {
        "BUTTON_TEXT": "Ενημέρωση πρακτόρων στην ομάδα",
        "TITLE": "Προσθήκη πρακτόρων στην ομάδα - {teamName}",
        "DESC": "Προσθέστε Πράκτορες στη νέα σας ομάδα. Όλοι αυτοί οι πράκτορες θα ειδοποιηθούν όταν μια συνομιλία ανατεθεί σε αυτήν την ομάδα."
      },
      "EDIT_WIZARD_DETAILS": {
        "TITLE": "Λεπτομέρειες Ομάδας",
        "ROUTE": "settings_teams_edit",
        "BODY": "Αλλαγή ονόματος, περιγραφής και άλλων λεπτομερειών."
      },
      "EDIT_WIZARD_AGENTS": {
        "TITLE": "Επεξεργασία Πρακτόρων",
        "ROUTE": "settings_teams_edit_members",
        "BODY": "Διαχείριση πρακτόρων της ομάδας σας."
      },
      "EDIT_WIZARD_FINISH": {
        "TITLE": "Τέλος",
        "ROUTE": "settings_teams_edit_finish",
        "BODY": "Είσαστε έτοιμοι να ξεκινήσετε!"
      }
    },
    "TEAM_FORM": {
      "ERROR_MESSAGE": "Δεν ήταν δυνατή η αποθήκευση των λεπτομερειών της ομάδας. Δοκιμάστε ξανά."
    },
    "AGENTS": {
      "AGENT": "ΠΡΑΚΤΟΡΑΣ",
      "EMAIL": "EMAIL",
      "BUTTON_TEXT": "Προσθήκη πρακτόρων",
      "ADD_AGENTS": "Προσθήκη πρακτόρων στην ομάδα σας...",
      "SELECT": "επιλέξτε",
      "SELECT_ALL": "επιλογή όλων των πρακτόρων",
      "SELECTED_COUNT": "{selected} από τους {total} πράκτορες επιλέχθηκαν."
    },
    "ADD": {
      "TITLE": "Προσθήκη πρακτόρων στην ομάδα - {teamName}",
      "DESC": "Προσθέστε Πράκτορες στη νέα σας ομάδα. Αυτό σας επιτρέπει να συνεργάζεστε ως ομάδα σε συνομιλίες και να ενημερώνεστε για νέα συμβάντα στην συνομιλία.",
      "SELECT": "επιλέξτε",
      "SELECT_ALL": "επιλογή όλων των πρακτόρων",
      "SELECTED_COUNT": "{selected} από τους {total} πράκτορες επιλέχθηκαν.",
      "BUTTON_TEXT": "Προσθήκη πρακτόρων",
      "AGENT_VALIDATION_ERROR": "Επιλέξτε τουλάχιστον ένα πράκτορα."
    },
    "FINISH": {
      "TITLE": "Η ομάδα σας είναι έτοιμη!",
      "MESSAGE": "Τώρα μπορείτε να συνεργαστείτε ως ομάδα σε συνομιλίες. Καλή υποστήριξη ",
      "BUTTON_TEXT": "Τέλος"
    },
    "DELETE": {
      "BUTTON_TEXT": "Διαγραφή",
      "API": {
        "SUCCESS_MESSAGE": "Η ομάδα διαγράφηκε με επιτυχία.",
        "ERROR_MESSAGE": "Δεν ήταν δυνατή η διαγραφή της ομάδας. Δοκιμάστε ξανά."
      },
      "CONFIRM": {
        "TITLE": "Are you sure you want to delete the team?",
        "PLACE_HOLDER": "Παρακαλώ πληκτρολογήστε {teamName} για επιβεβαίωση",
        "MESSAGE": "Διαγράφοντας την ομάδα θα αφαιρέσετε και τις αναθέσεις συνομιλιών σε αυτήν την ομάδα.",
        "YES": "Διαγραφή ",
        "NO": "Άκυρο"
      }
    },
    "SETTINGS": "Ρυθμίσεις",
    "FORM": {
      "UPDATE": "Ενημέρωση ομάδας",
      "CREATE": "Δημιουργία Ομάδας",
      "NAME": {
        "LABEL": "Όνομα ομάδας",
        "PLACEHOLDER": "Παράδειγμα: Πωλήσεις, Υποστήριξη Πελατών"
      },
      "DESCRIPTION": {
        "LABEL": "Περιγραφή Ομάδας",
        "PLACEHOLDER": "Σύντομη περιγραφή της ομάδας."
      },
      "AUTO_ASSIGN": {
        "LABEL": "Επιτρέψτε την αυτόματη ανάθεση σε αυτήν την ομάδα."
      },
      "SUBMIT_CREATE": "Δημιουργία Ομάδας"
    }
  }
}
